import type { BankAccount } from '@modules/husleie-framework/src/types/BankAccount.entity';

const enum RentDurationEnum {
  LIMITED = 'LIMITED',
  UNLIMITED = 'UNLIMITED',
}
type RentDurationType = RentDurationEnum.LIMITED | RentDurationEnum.UNLIMITED;

const enum LimitedRentDurationEnum {
  OWN_USE = 'OWN_USE',
  RENOVATION = 'RENOVATION',
  LOCATION_REQUIRED = 'LOCATION_REQUIRED',
}
type LimitedRentDurationType =
  | LimitedRentDurationEnum.OWN_USE
  | LimitedRentDurationEnum.RENOVATION
  | LimitedRentDurationEnum.LOCATION_REQUIRED;

interface Rent {
  durationType?: RentDurationType;
  startDate?: string;
  endDate?: string;

  /* Limited Rent */
  limitedRentDurationType?: LimitedRentDurationType;
  limitedRentReason?: string;

  bindingPeriod?: number;
  noticePeriod?: number;

  rent?: number;
  paymentDay?: number;

  landlord?: {
    bankAccount?: BankAccount;
  };
}

export { Rent, RentDurationType, RentDurationEnum, LimitedRentDurationType, LimitedRentDurationEnum, BankAccount };
